import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import PropTypes from "prop-types";
import {
    Avatar,
    Box,
    Grid,
    Divider,
    Button,
    Popover,
    Tabs,
    Tab,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TextField,
    TableSortLabel,
    InputAdornment,
    Paper,
    Pagination,
    PaginationItem,
    Select,
    Typography,
    usePagination,
    Container,
    CardContent,
    Card,
    ClickAwayListener,
    MenuItem,
    MenuList,
    Grow,
    Popper,
    FormGroup,
    FormControlLabel,
    Checkbox,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import planningImg from "../../../assets/images/home/planning.svg";
import saveImg from "../../../assets/images/home/save.svg";
import fileBrowser from "../../../icons/file-browser.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icons/filter.svg";
import ConfirmDialog from "../../../components/inbox/ConfirmDialog";
import * as Util from "../../../services/global.service";
import Search from "@mui/icons-material/Search";
import cssVariables from "../../../theme/cssVariables";
import exports from "../../../assets/images/export.png";
import thanya from "../../../assets/images/imgMock/thanya.jpg";
import viewDashboard from "../../../assets/images/viewDashboard.svg";
import { ReactComponent as ChevronExpandDown } from "../../../assets/icons/chevron-expand-down.svg";
import { ReactComponent as ChevronExpandUp } from "../../../assets/icons/chevron-expand-up.svg";
import { ReactComponent as Eye } from "../../../assets/images/eye.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/delete.svg";
import { ReactComponent as FilterStatus } from "../../../assets/icons/filter-status.svg";
import { ReactComponent as Nodata } from "../../../assets/icons/nodata.svg";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import StarIcon from '@mui/icons-material/Star';
import evaluateService from "../../../services/evaluate.service";
import requestSent from "../../../assets/images/request-sent.svg";

function StylePaper(props) {
    return (
        <Paper sx={{ padding: "0.5rem 1.5rem", minHeight: "65vh" }}>
            {props.children}
        </Paper>
    );
}
const styles = {
    path: {
        color: "#68717A",
    },
    paPlanning: {
        marginTop: "-12px",
        marginLeft: "19px",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    lastToolBar: {
        marginTop: "0px",
    },
    blueBadge: {
        background: "rgba(93, 161, 150, 0.15)",
        padding: "5px 12px",
        color: "#5DA196",
        border: "1px solid #5DA196",
        borderRadius: "4px"
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    colorText: {
        color: "#404349",
        fontWeight: "400",
        paddingLeft: "10px"
    },
    box: {
        width: "calc(50% - 30px)",
        "flex-direction": "row",
        margin: "15px 15px",
    },
    content: {
        background: "#FFFFFF",
        "box-shadow": "0px 0px 5px rgba(0, 0, 0, 0.1)",
        "border-radius": "10px",
        padding: "17px 22px",
        height: "100%",
    },
    emty: {
        display: "flex",
        "flex-flow": "column wrap",
        "background-color": "#fff",
        height: "220px",
        "box-shadow": "0px 0px 5px rgb(0 0 0 / 10%)",
        "border-radius": "10px",
        "justify-content": "center",
        "align-items": "center",
    },
    twoContent: {
        display: "flex",
        "justify-content": "center",
        "flex-direction": "row",
        "align-items": "center",
    },
    boxTwoContent: {
        display: "flex",
        "justify-content": "space-between",
        "flex-direction": "row",
        "align-items": "center",
    }
};

const useStyles = makeStyles({
    plusSvg: {
        "& > path": {
            fill: "#fff",
            stroke: "#fff",
        },
    },
    draggingListItem: {
        background: 'rgb(235,235,235)'
    },
    toggleBtnRoot: {
        background: `transparent !important`,
        color: "#6B6B6B !important",
        width: "320px",
        border: "none !important",
    },
    toggleBtnSelected: {
        background: `${cssVariables.color.primary}!important`,
        color: "#fff!important",
    },
    flexPaper: {
        flex: 1,
        minWidth: 350,
        "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
        "border-radius": "10px !important        ",
        minHeight: "570px"
    },
    tab: {
        fontSize: "16px !important",
        fontWeight: "300 !important",
        // color: "#A3A3A3 !important",
        '&.Mui-selected': {
            color: cssVariables.color.primary + " !important"
        }
    },
    root: {
        display: 'flex',
        width: "100%",
        flexWrap: 'wrap',
        fontSize: "16px",
        lineHeight: "24px",
        fontWeight: "400",
    },
    iconContainer: {
        width: 40,
        height: 40,
        borderRadius: 5,
        marginTop: 3,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    profileContainer: {
        width: 40,
        height: 40,
        borderRadius: "50%",
        marginTop: 3,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    statusBadge: {
        width: "fit-content",
        minWidth: "120px",
        borderRadius: "5px",
        padding: "10px",
    },
    draftBg: {
        background: "#EFB76D26"
    },
    draftText: {
        color: "#EFB76D"
    },
    pendingBg: {
        background: "#F280261A"
    },
    pendingText: {
        color: "#F28026"
    },
    approveBg: {
        background: "#5DA19626"
    },
    approveText: {
        color: "#5DA196"
    },
    rejectedBg: {
        background: "#CC605826"
    },
    rejectedText: {
        color: "#CC6058"
    },
    notStartBg: {
        background: "#C4C4C41A"
    },
    notStartText: {
        color: "#C4C4C4",
    },
    cancelBg: {
        background: "#CC605826"
    },
    cancelText: {
        color: "#CC6058",
    },
    cancelPendingBg: {
        background: "#82828226"
    },
    cancelPendingText: {
        color: "#828282",
    },
    completedBg: {
        background: "rgba(93, 161, 150, 0.15);",
    },
    completedText: {
        color: "#5DA196",
    },
    blueBg: {
        background: "#6694CC",
    },
    purpleBg: {
        background: "#7580BD",
    },
    btnContainer: {
        width: "100%",
        display: "flex",
        alignItems: "flex-start",
        flexGrow: 1,
    },
    btnActive: {
        background: cssVariables.color.primary,
        color: `${cssVariables.color.white}!important`,
        "&:hover": {
            backgroundColor: "#4f8a80",
        },
    },
    btnInactive: {
        "&:hover": {
            backgroundColor: "#5da19626",
        },
    },
    btn: {
        transition: "0.2s",
        cursor: "pointer",
        borderRadius: "5px",
        padding: "10px",
        color: cssVariables.color.black,
    },
    paginationRoot: {
        color: `${cssVariables.color.primary}`,
        backgroundColor: "white!important",
        minWidth: "30px!important",
        padding: "5px!important",
    },
    paginationSelected: {
        color: "white!important",
        border: "1px solid rgba(93, 161, 150, 0.5)!important",
        backgroundColor: `${cssVariables.color.primary}!important`,
        minWidth: "30px!important",
        padding: "5px!important",
    },
    tableHover: {
        transition: "0.5s",
        "&:hover": {
            // background: "#4043490f",
            boxShadow: "3px 3px 5px rgba(0, 0, 0, 0.1)",
            cursor: "pointer",
        },
    },
    profileContainer: {
        width: 70,
        height: 70,
        borderRadius: "50%",
        marginTop: 3,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
});
function NoData() {
    const { t } = useTranslation();
    return (
        <TableRow>
            <TableCell colSpan={4}>
                <Box
                    textAlign="center"
                    sx={{ fontWeight: 300, flexFlow: "column" }}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Box>
                        <img src={fileBrowser} alt="browser" />
                    </Box>
                    <Box>
                        <Typography>{t("label.nodata")}</Typography>
                    </Box>
                </Box>
            </TableCell>
        </TableRow>
    );
}

function CustomPagination(props) {
    const { t } = useTranslation();
    const useStyles = makeStyles({
        paginationRoot: {
            color: `${cssVariables.color.primary}`,
            backgroundColor: "white!important",
            minWidth: "30px!important",
            padding: "5px!important",
        },
        paginationSelected: {
            color: "white!important",
            border: "1px solid rgba(93, 161, 150, 0.5)!important",
            backgroundColor: `${cssVariables.color.primary}!important`,
            minWidth: "30px!important",
            padding: "5px!important",
        },
    });
    const classes = useStyles();
    const List = styled("ul")({
        listStyle: "none",
        padding: 0,
        margin: 0,
        display: "flex",
    });
    const { items } = usePagination({
        count: props.count,
        showFirstButton: true,
        showLastButton: true,
    });
    return (
        <nav>
            <List>
                {items.length > 0 ? (
                    items.map(({ page, type, selected, ...item }, index) => {
                        let children = null;
                        selected = type === "page" && page === props.selected ? props.selected : selected
                        if (type === "start-ellipsis" || type === "end-ellipsis") {
                            children = "…";
                        } else if (type === "page") {
                            children = (
                                <Button
                                    {...item}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {page}
                                </Button>
                            );
                        } else if (type === "first" || type === "last") {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "first" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {type === "first" ? <>&lt;&lt;</> : <>&gt;&gt;</>}
                                </Button>
                            );
                        } else {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "previous" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    variant="outlined"
                                    classes={{
                                        root: classes.paginationRoot,
                                    }}
                                >
                                    {type === "previous"
                                        ? t("label.previous")
                                        : type === "next"
                                            ? t("label.next")
                                            : ""}
                                </Button>
                            );
                        }
                        return <li key={index}>{children}</li>;
                    })

                ) : (
                    <></>
                )}
                {props.setCurrentPage(items)}
            </List>
        </nav>
    );
}

function formatData(data) {
    let result = []

    if (data.out ?? false) {
        for (const key of Object.keys(data.out)) {
            let tmpList = []
            tmpList = data.out[key].map(item => {
                return {
                    serial: item.serial ?? "",
                    name: item.name ?? "",
                    evaluate_name: item.evaluate_name ?? "",
                    type: item.type ?? "",
                    start_date: item.start_date ?? "",
                    end_date: item.end_date ?? "",
                    photo: item.photo ?? "",
                    due_date: item.due_date ?? "",
                    status: item.status ?? "",
                }
            })
            result = [...result, ...tmpList]
        }
    }

    return result
}
const PerformanceEvaluation = (props) => {
    const Ratings = styled(Rating)({
        '& .MuiRating-icon': {
            color: '#F7B254 !important',
        },
    });
    const { t, i18n } = useTranslation();
    const _ = require("lodash");
    const [list, setList] = React.useState([]);
    const [filteredList, setFilteredList] = React.useState([]);
    const [itemsProgress, setItemsProgress] = React.useState([]);
    const [mainItemsProgress, setMainItemsProgress] = React.useState([]);
    const classes = useStyles();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(false);
    const [searchProgress, setSearchValueProgress] = React.useState("");
    const [perPage, setPerPage] = React.useState(10);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalPage, setTotalPage] = React.useState(1);
    const [checkResired, setCheckRsquired] = React.useState({});
    const [reSet, setreSet] = React.useState(false);
    const anchorRef = React.useRef(null);
    const [completed, setCompleted] = React.useState(true);
    const [progress, setProgress] = React.useState(true);
    const [notStarted, setNotStarted] = React.useState(true);
    const [competencyFormSelect, setCompetencyForm] = React.useState([]);
    const [competencyFormSelectValue, setCompetencyFormValue] = React.useState("");
    const [hasPrevious, setHasPrevious] = React.useState(false);
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    useEffect(() => {
        handleGetList()
    }, []);
    const handleGetList = () => {
        evaluateService.listMyEvaluate().then(
            (response) => {
                setMainItemsProgress(response?.data?.my_evaluate !== undefined ? response?.data?.my_evaluate : []);
                setItemsProgress(response?.data?.my_evaluate !== undefined ? response?.data?.my_evaluate : []);
                setHasPrevious(response?.data?.has_previous);
            },
        )
    };

    // go to detail page
    const handleGoToDetail = (serial, isNew, type) => {
        if (isNew === true) {
            evaluateService.logIsRead(serial).then(
                (response) => {
                    if (type === "probation") {
                        navigate("/kpi/probation-evaluation/" + serial, { replace: false });
                    } else {
                        navigate("/kpi/evaluation/" + serial, { replace: false });
                    }
                },
            )
        } else {
            if (type === "probation") {
                navigate("/kpi/probation-evaluation/" + serial, { replace: false });
            } else {
                navigate("/kpi/evaluation/" + serial, { replace: false });
            }
        }
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Escape') {
            setOpen(false);
        }
    }
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };
    const filterActiveSerach = (data) => {
        let result = []
        let dataFilter = JSON.parse(JSON.stringify(data))
        if (completed === false && progress === false && notStarted === false) {
            setItemsProgress([])
        } else if (completed === true && progress === true && notStarted === true) {
            setItemsProgress(data)
        } else {
            if (completed === true && progress === true) {
                let resultData = dataFilter.filter(rs => rs?.status?.code === "completed" || rs?.status?.code === "in_progress");
                result = resultData
                setItemsProgress(result)
            } else if (progress === true && notStarted === true) {
                let resultData = dataFilter.filter(rs => rs?.status?.code === "not_started" || rs?.status?.code === "in_progress");
                result = resultData
                setItemsProgress(result)
            } else if (notStarted === true && completed === true) {
                let resultData = dataFilter.filter(rs => rs?.status?.code === "completed" || rs?.status?.code === "not_started");
                result = resultData
                setItemsProgress(result)
            } else {
                if (completed === true) {
                    let resultData = dataFilter.filter(rs => rs?.status?.code === "completed");
                    result = resultData
                    setItemsProgress(result)
                } else if (progress === true) {
                    let resultData = dataFilter.filter(rs => rs?.status?.code === "in_progress");
                    result = resultData
                    setItemsProgress(result)
                } else if (notStarted === true) {
                    let resultData = dataFilter.filter(rs => rs?.status?.code === "not_started");
                    result = resultData
                    setItemsProgress(result)
                }
            }
        }
    };

    const EditNotActive = (data) => {
        if (data === "completed") {
            setCompleted(!completed)
        } else if (data === "progress") {
            setProgress(!progress)
        } else if (data === "notStarted") {
            setNotStarted(!notStarted)
        } else if (data === "selectAll") {
            if (completed === true && progress === true && notStarted === true) {
                setCompleted(false)
                setProgress(false)
                setNotStarted(false)
            } else if (completed === false && progress === false && notStarted === false) {
                setCompleted(true)
                setProgress(true)
                setNotStarted(true)
            } else if (completed === true || progress === true || notStarted === true) {
                setCompleted(true)
                setProgress(true)
                setNotStarted(true)
            }
        }
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    const handleSearchProgress = (event) => {
        setSearchValueProgress(event.target.value);
    };

    const currentData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * perPage;
        const lastPageIndex = firstPageIndex + perPage;
        return itemsProgress
            .slice(firstPageIndex, lastPageIndex);
    }, [itemsProgress, currentPage, perPage]);
    const handleTotalPage = () => {
        const List = itemsProgress
        const totalPage =
            Math.ceil(List.length / perPage) === 0
                ? 1
                : Math.ceil(List.length / perPage);
        setTotalPage(totalPage);
    };
    useEffect(() => {
        handleTotalPage();
    }, [itemsProgress, perPage]);

    useEffect(() => {
        let update = checkResired
        if (Object.keys(checkResired)[0] !== undefined) {
            if (update[Object.keys(checkResired)[0]] === false) {
                currentData.sort(function (b, a) {
                    if (a[Object.keys(checkResired)[0]] > b[Object.keys(checkResired)[0]]) {
                        return -1;
                    }
                    if (b[Object.keys(checkResired)[0]] > a[Object.keys(checkResired)[0]]) {
                        return 1;
                    }
                    return 0;
                });
                setreSet(!reSet)
            } else if (update[Object.keys(checkResired)[0]] === true) {
                currentData.sort(function (a, b) {
                    if (a[Object.keys(checkResired)[0]] > b[Object.keys(checkResired)[0]]) {
                        return -1;
                    }
                    if (b[Object.keys(checkResired)[0]] > a[Object.keys(checkResired)[0]]) {
                        return 1;
                    }
                    return 0;
                });
                setreSet(!reSet)
            }
        }
    }, [currentData]);

    useEffect(() => {
        filterActiveSerach(mainItemsProgress)
    }, [completed, progress, notStarted]);

    const handlePerPageChange = (event) => {
        setPerPage(event.target.value);
    };
    const handleSetCurrentPage = (value) => {
        const getSelectedPage = value.filter(item => item.type === "page" && item.selected)
        setCurrentPage(getSelectedPage.length > 0 ? getSelectedPage[0].page : 1)
    };
    const toTimestamp = (strDate) => {
        if (strDate !== "" && strDate !== null && strDate !== undefined) {
            const dt = Date.parse(strDate);
            return dt / 1000;
        } else {
            return 0;
        }
    }
    let sortData = (key, check1) => {
        let update = checkResired
        if (check1 === false && update[key] !== check1) {
            if (key === "data_as_of") {
                currentData.sort(function (b, a) {
                    if (toTimestamp(a[key]) > toTimestamp(b[key])) {
                        return -1;
                    }
                    if (toTimestamp(b[key]) > toTimestamp(a[key])) {
                        return 1;
                    }
                    return 0;
                });
            } else if (key === "options") {
                currentData.sort(function (b, a) {
                    if (a[key].name_en > b[key].name_en) {
                        return -1;
                    }
                    if (b[key].name_en > a[key].name_en) {
                        return 1;
                    }
                    return 0;
                });
            } else {
                currentData.sort(function (b, a) {
                    if (a[key] > b[key]) {
                        return -1;
                    }
                    if (b[key] > a[key]) {
                        return 1;
                    }
                    return 0;
                });
            }
            update = { [key]: false }
            setCheckRsquired(update)
            setreSet(!reSet)
        } else if (check1 === true && update[key] !== check1) {
            if (key === "data_as_of") {
                currentData.sort(function (a, b) {
                    if (toTimestamp(a[key]) > toTimestamp(b[key])) {
                        return -1;
                    }
                    if (toTimestamp(b[key]) > toTimestamp(a[key])) {
                        return 1;
                    }
                    return 0;
                });
            } else if (key === "options") {
                currentData.sort(function (a, b) {
                    if (a[key].name_en > b[key].name_en) {
                        return -1;
                    }
                    if (b[key].name_en > a[key].name_en) {
                        return 1;
                    }
                    return 0;
                });
            } else {
                currentData.sort(function (a, b) {
                    if (a[key] > b[key]) {
                        return -1;
                    }
                    if (b[key] > a[key]) {
                        return 1;
                    }
                    return 0;
                });

            }
            update = { [key]: true }
            setCheckRsquired(update)
            setreSet(!reSet)
        }


    }
    const onScroll = (evt) => {
        if (evt !== undefined && evt !== null) {
            if (open) {
                setOpen(false)
            }
        }
    }

    useEffect(() => {
        // getDataCompetencyYear()
    }, []);
    let getDataCompetencyYear = () => {
        evaluateService.cycle().then(
            (response) => {
                if (response?.data !== undefined && response.data.length > 0) {
                    setCompetencyForm(response.data)
                    let filterData = response.data.filter((e) => e.is_default === true)
                    if (filterData.length > 0) {
                        setCompetencyFormValue(filterData[0].value)
                    } else {
                        setCompetencyFormValue(response.data[0].value)
                    }
                }
            },
        );
    }
    const handleChangeWorkloadForm = (event) => {
        setCompetencyFormValue(event.target.value);
    };

    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: "#343A40",
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#343A40",
            color: "#FFFFFF",
            padding: "11px 15px",
            fontSize: "14px"
        },
    }));
    const openNewTab = (val) => {
        const newWindow = window.open(val, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }
    return (
        <Box
            sx={{
                backgroundColor: "background.default",
                minHeight: "100%",
                py: 3,
            }}
        >
            <Container maxWidth="xl">
                <Grid container pt={2} pb={2}>
                    <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t('label.home')}</span> / <span style={styles.end} >{t("sidebar.label.evaluation")}</span></Typography>
                </Grid>
                <Grid container spacing={2}>
                    <Grid container item sx={{ display: "flex", justifyContent: "space-between" }} >
                        <Grid item md={8} xs={8}>
                            <Box >
                                <Typography color="#404349" fontSize={36} lineHeight={1.495} fontWeight={600} >
                                    {t("sidebar.label.evaluation")}
                                </Typography>
                                <Box sx={{ flex: 2 }}></Box>
                            </Box>
                        </Grid>
                        {/* TESTING FEATURE */}
                        {
                            hasPrevious &&
                            /* (process.env.REACT_APP_MODE !== "uat" && process.env.REACT_APP_MODE !== "staging" && process.env.REACT_APP_MODE !== "production") && */
                            <Grid item md={4} xs={4} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                                <Box sx={{ ".MuiButton-root": { padding: "6px 10px" }, display: "flex", justifyContent: "flex-end" }}>
                                    <Button onClick={() => openNewTab(`/kpi/evaluation/previous`)} sx={{ display: "flex", height: "45px", "text-transform": "none" }} variant="dashed-solid" ><Box sx={{ display: "flex", "align-items": "center" }}><img style={{ display: "block", "margin-right": "10px" }} src={requestSent} alt="export"></img><Typography color="#404349">{t('evaluation.previousEvaluation')}</Typography></Box></Button>
                                </Box>
                            </Grid>
                        }
                    </Grid>
                    <Grid item xs sx={{ paddingTop: "30px !important" }}>
                        <Grid container >
                            <Grid container item >
                                <div className={classes.root}>
                                    <Paper className={classes.flexPaper} >
                                        <Box
                                            px="32px"
                                        >
                                            <Box
                                                px="25px"
                                                py="19px"
                                                sx={{ display: "flex", "flex-direction": "row" }}
                                            >
                                                <Box sx={{ display: "flex", "flex-direction": "row", width: "28.51%" }} pr="15px">
                                                    <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                        {t("evaluation.formName")}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ display: "flex", "flex-direction": "row", width: "14.06%" }} pr="15px">
                                                    <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                        {t('evaluation.formType')}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ display: "flex", "flex-direction": "row", width: "17.55%" }} pr="15px">
                                                    <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                        {t('evaluation.evaluator')}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ display: "flex", "flex-direction": "row", width: "11.14%" }} pr="15px">
                                                    <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                        {t('evaluation.dueDate')}
                                                    </Typography>
                                                    <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                        <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("due_date", true)} />
                                                        <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("due_date", false)} />
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ display: "flex", "flex-direction": "row", width: "15.41%" }} pr="15px">
                                                    <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                        {t('evaluation.evaluatorRating')}
                                                    </Typography>
                                                    <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                        <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("evaluator_rating", true)} />
                                                        <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("evaluator_rating", false)} />
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ display: "flex", "flex-direction": "row", width: "13.33%" }}>
                                                    <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                        {t('label.formStatus')}
                                                    </Typography>
                                                    <Stack direction="row" spacing={2}>
                                                        <div>
                                                            <FilterStatus
                                                                ref={anchorRef}
                                                                id="composition-button"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={handleToggle}
                                                            />
                                                            <Popper
                                                                open={open}
                                                                anchorEl={anchorRef.current}
                                                                role={undefined}
                                                                placement="bottom-start"
                                                                transition
                                                                disablePortal
                                                                style={{ "z-index": "1" }}
                                                            >
                                                                {({ TransitionProps, placement }) => (
                                                                    <Grow
                                                                        {...TransitionProps}
                                                                        style={{
                                                                            transformOrigin:
                                                                                placement === 'bottom-start' ? 'left top' : 'left bottom',
                                                                        }}
                                                                    >
                                                                        <Paper sx={{ "margin-top": "5px !important" }}>
                                                                            <ClickAwayListener onClickAway={handleClose}>
                                                                                <MenuList
                                                                                    autoFocusItem={open}
                                                                                    id="composition-menu"
                                                                                    aria-labelledby="composition-button"
                                                                                    onKeyDown={handleListKeyDown}
                                                                                >

                                                                                    <Box px="16px" py="6px">
                                                                                        <FormGroup>
                                                                                            <FormControlLabel control={<Checkbox indeterminate={completed !== progress || progress !== notStarted || notStarted !== completed} onChange={e => EditNotActive("selectAll")} checked={completed === true && progress === true && notStarted === true ? true : false} />} label={t('competency.selectAll')} />
                                                                                            <FormControlLabel control={<Checkbox onChange={e => EditNotActive("completed")} checked={completed} />} label={t('label.completed')} />
                                                                                            <FormControlLabel control={<Checkbox onChange={e => EditNotActive("progress")} checked={progress} />} label={t('label.inProgress')} />
                                                                                            <FormControlLabel control={<Checkbox onChange={e => EditNotActive("notStarted")} checked={notStarted} />} label={t('label.notStarted')} />
                                                                                        </FormGroup>
                                                                                    </Box>
                                                                                </MenuList>
                                                                            </ClickAwayListener>
                                                                        </Paper>
                                                                    </Grow>
                                                                )}
                                                            </Popper>
                                                        </div>
                                                    </Stack>
                                                </Box>

                                            </Box>
                                            <Divider width="100%" />
                                        </Box>
                                        {currentData !== undefined && currentData !== null && currentData.length > 0 ? currentData.map((row, index) => (
                                            <Box px="32px" >
                                                <Box sx={{ width: "100%", position: "relative", transition: "0.5s", "&:hover": { boxShadow: "3px 5px 5px rgba(0, 0, 0, 0.1)", cursor: "pointer", "z-index": "1" } }} key={row?.serial} onClick={() => handleGoToDetail(row?.serial, row?.is_new, row?.evaluate_template_type)} >
                                                    <Box
                                                        sx={{ minHeight: "96px", background: "#FFF", width: "100%", display: "flex", "align-items": "center" }}
                                                        px="25px" py="20px"
                                                    >
                                                        <Box sx={{ width: "28.51%" }} pr="15px" >
                                                            <Box
                                                                display="flex"
                                                                sx={{
                                                                    flexFlow: "column",
                                                                    textAlign: "left",
                                                                    // marginLeft: 2,
                                                                    position: "relative",
                                                                }}
                                                            >
                                                                {row?.is_new ? (
                                                                    <div
                                                                        style={{
                                                                            position: "absolute",
                                                                            top: "calc(50% - 5px)",
                                                                            left: "-25px",
                                                                            width: "10px",
                                                                            height: "10px",
                                                                            background: "#CC6058",
                                                                            borderRadius: "50%",
                                                                        }}
                                                                    ></div>
                                                                ) : (
                                                                    <></>
                                                                )}
                                                                <BootstrapTooltip title={Util.formatData(row?.form?.name, "")} placement="top">
                                                                    <Typography
                                                                        variant="h4"
                                                                        fontWeight={500}
                                                                        fontSize={18}
                                                                        lineHeight="27px"
                                                                        color="#404349"
                                                                        sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}
                                                                    >
                                                                        {Util.formatData(row?.form?.name, "")}
                                                                    </Typography>
                                                                </BootstrapTooltip>
                                                                {Util.formatData(row?.options?.position, false) !== false ?
                                                                    <Typography lineHeight="23.92px" fontSize={16} color="#A3A3A3" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                        {row?.options?.position}
                                                                    </Typography>
                                                                    :
                                                                    null
                                                                }
                                                                {Util.formatData(row?.options?.organization, false) !== false ?
                                                                    <Typography lineHeight="23.92px" fontSize={16} color="#A3A3A3" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                        ({row?.options?.organization})
                                                                    </Typography>
                                                                    :
                                                                    null
                                                                }
                                                                <Typography variant="sub_label" lineHeight="27px">
                                                                    ({Util.dateMonthFormatAdmin(row?.form?.start_date)} - {Util.dateMonthFormatAdmin(row?.form?.end_date)})
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                        <Box sx={{ width: "14.06%" }} pr="15px">
                                                            <Typography fontWeight="400" fontSize={18} lineHeight="23.92px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }} color="#404349">
                                                                {Util.formatData(row?.evaluate_type?.name, "")}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ width: "17.55%", display: "flex", justifyContent: "flex-start", alignItems: "center" }} pr="15px">
                                                            <Avatar
                                                                src={Util.formatData(row?.evaluator?.photo, "")}
                                                                sx={{
                                                                    cursor: "pointer",
                                                                    width: 40,
                                                                    height: 40,
                                                                }}
                                                            />
                                                            <Box ml={(2)} sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                <Typography pb={row?.evaluator?.options?.name_th !== null && row?.evaluator?.options?.name_th !== undefined && row?.evaluator?.options?.name_th !== "" ? "0" : "5px"} fontWeight="400" fontSize={18} lineHeight="26.91px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }} color="#404349">
                                                                    {Util.formatData(row?.evaluator?.fullname, "")}
                                                                </Typography>
                                                                {/* {row?.evaluator?.options?.name_th !== null && row?.evaluator?.options?.name_th !== undefined && row?.evaluator?.options?.name_th !== "" ?
                                                                    <Typography fontWeight="400" fontSize={14} lineHeight="20.93px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                        {row?.evaluator?.options?.name_th}
                                                                    </Typography>
                                                                    :
                                                                    null
                                                                } */}
                                                            </Box>
                                                        </Box>
                                                        <Box sx={{ display: "flex", "flex-direction": "column", width: "11.14%" }} pr="15px">
                                                            <Typography fontWeight="400" fontSize={16} color="#404349" lineHeight="24px" sx={{ color: toTimestamp(new Date()) > toTimestamp(row?.due_date) && row?.status?.code !== "completed" ? "#CC6058" : "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                {Util.dateDayFormatAdmin(row?.due_date, "")}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ display: "flex", "flex-direction": "column", width: "15.41%" }} pr="15px">
                                                            {((row?.evaluator_rating !== null && row?.evaluator_rating !== "") || (row?.evaluator_rating_percent !== null && row?.evaluator_rating_percent !== "")) && row?.status?.code === "completed" ?
                                                                <Box sx={{ display: "flex", 'align-items': "center", }}>
                                                                    <Ratings fontSize={19} readOnly name="text-feedback" emptyIcon={<StarIcon fontSize="inherit" />} defaultValue={formatData(Number(row?.evaluator_rating).toFixed(1), 0)} max={1} />
                                                                    <Box>
                                                                        {Util.formatData(row?.evaluator_rating, false) !== false &&
                                                                            <Typography fontSize={16} pl="5px" pr="5px" fontWeight="500" color="#404349">
                                                                                {Util.formatData(Number(Util.formatData(row?.evaluator_rating, "0")).toFixed(row?.score_decimal), "0")}
                                                                            </Typography>
                                                                        }
                                                                        {Util.formatData(row?.evaluator_rating_percent, false) !== false ?
                                                                            <Typography fontSize={16} pl="5px" pr="5px" fontWeight="500" color="#404349">
                                                                                {Util.formatData(Number(Util.formatData(row?.evaluator_rating_percent, "0")).toFixed(row?.score_decimal), "0")}%
                                                                            </Typography>
                                                                            : null}
                                                                    </Box>
                                                                </Box>
                                                                :
                                                                <Box sx={{ display: "flex", 'align-items': "center", }}>
                                                                    <Rating fontSize={19} readOnly name="text-feedback" emptyIcon={<StarIcon fontSize="inherit" />} defaultValue={formatData(Number(row?.evaluator_rating).toFixed(1), 0)} max={1} />
                                                                    <Typography fontSize={18} pl="5px" pr="5px" fontWeight="400">
                                                                        {"-"}
                                                                    </Typography>
                                                                </Box>
                                                            }
                                                        </Box>
                                                        <Box sx={{ width: "13.33%" }}>
                                                            <Box py="8px" px="20px" sx={{ "max-width": "100%", width: "max-content", border: row?.status?.code === "not_started" ? "1px solid #DADADA" : "none", "border-radius": "5px", background: row?.status?.code === "in_progress" ? "#EFB76D1A" : row?.status?.code === "completed" ? "#5DA1961A" : "none" }} >
                                                                <Typography fontSize={16} lineHeight="24px" fontWeight={500} color={row?.status?.code === "in_progress" ? "#EFB76D" : row?.status?.code === "completed" ? "#5DA196" : "#DADADA"} sx={{ "text-align": "center", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                    {row?.status?.name}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                                <Divider width="100%" />
                                            </Box>
                                        ))
                                            :
                                            <Box sx={{ "padding-top": "50px", "text-align": "center", "padding-bottom": "500px" }}>
                                                <Nodata />
                                                <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                                    {t('label.noDataFilter')}
                                                </Typography>
                                                <Typography color="#A0A0A0" fontWeight="400" fontSize={16} lineHeight="24px" >
                                                    {t('label.tryChangingFilter')}
                                                </Typography>
                                            </Box>
                                        }
                                    </Paper>
                                </div>
                            </Grid>

                            <Grid container mt={1} spacing={2}>
                                <Grid item xs sm md display="flex" alignItems="center">
                                    <Box mr={1}>
                                        <Typography variant="s14_fw400">{t("label.showMaxItems")}</Typography>
                                    </Box>
                                    <Select
                                        id="pagination"
                                        variant="outlined"
                                        defaultValue={10}
                                        value={perPage}
                                        onChange={handlePerPageChange}
                                        displayEmpty
                                        size="small"
                                        className="white-bg"
                                    >
                                        <MenuItem value={10}>
                                            <Typography style={{ fontWeight: "300" }}>10</Typography>
                                        </MenuItem>
                                        <MenuItem value={20}>
                                            <Typography style={{ fontWeight: "300" }}>20</Typography>
                                        </MenuItem>
                                        <MenuItem value={30}>
                                            <Typography style={{ fontWeight: "300" }}>30</Typography>
                                        </MenuItem>
                                    </Select>
                                </Grid>
                                <Grid item display="flex" alignItems="center" ml="auto">
                                    <Typography variant="s14_fw400">
                                        {t("label.page")} {currentPage} {t("label.of")} {totalPage}
                                    </Typography>
                                </Grid>
                                <Grid item ml="auto" display="flex" alignItems="center">
                                    <CustomPagination
                                        setCurrentPage={handleSetCurrentPage}
                                        selected={currentPage}
                                        count={totalPage}
                                    ></CustomPagination>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

            </Container>
        </Box>
    );
};
export default PerformanceEvaluation;
